import { get } from 'lodash';

import FilterDefinition from 'helpers/search_filters/filter_definition';
import CurrencyFormatter from '../../search_filters/formatters/currency_formatter';
import MeasurementFormatter from '../../search_filters/formatters/measurement_formatter';

const buildSelector = path => query => get(query, `propertyFilter.${path}`);

export const apnNumber = new FilterDefinition({
  label: 'APN Number',
  value: buildSelector('apnNumber')
});

export const availableSF = new FilterDefinition({
  label: 'Available SF',
  type: FilterDefinition.types.range,
  formatter: new MeasurementFormatter(),
  minValue: buildSelector('minAvailableSF'),
  maxValue: buildSelector('maxAvailableSF'),
  unit: 'sf'
});

export const buildingSize = new FilterDefinition({
  label: 'Building Size',
  type: FilterDefinition.types.range,
  formatter: new MeasurementFormatter(),
  minValue: buildSelector('minBuildingSize'),
  maxValue: buildSelector('maxBuildingSize'),
  unit: 'sf'
});

export const ceilingHeight = new FilterDefinition({
  label: 'Ceiling Height',
  type: FilterDefinition.types.range,
  formatter: new MeasurementFormatter(),
  minValue: buildSelector('minCeilingHeight'),
  maxValue: buildSelector('maxCeilingHeight'),
  unit: 'f'
});

export const lotSize = new FilterDefinition({
  label: 'Lot Size',
  type: FilterDefinition.types.range,
  formatter: new MeasurementFormatter(),
  minValue: buildSelector('minLotSize'),
  maxValue: buildSelector('maxLotSize'),
  unit: buildSelector('lotUnits')
});

export const mortgageAmount = new FilterDefinition({
  label: 'Mortgage Amount',
  type: FilterDefinition.types.range,
  formatter: new CurrencyFormatter(),
  minValue: buildSelector('minMortgageAmount'),
  maxValue: buildSelector('maxMortgageAmount')
});

export const mortgageRecordedDate = new FilterDefinition({
  label: 'Mortgage Recorded Date',
  type: FilterDefinition.types.range,
  minValue: buildSelector('minMortgageRecordedDate'),
  maxValue: buildSelector('maxMortgageRecordedDate')
});

export const numKeys = new FilterDefinition({
  label: 'Number of Keys',
  type: FilterDefinition.types.range,
  minValue: buildSelector('minNumKeys'),
  maxValue: buildSelector('maxNumKeys')
});

export const numUnits = new FilterDefinition({
  label: 'Number of Units',
  type: FilterDefinition.types.range,
  minValue: buildSelector('minNumUnits'),
  maxValue: buildSelector('maxNumUnits')
});

export const yearBuilt = new FilterDefinition({
  label: 'Year Built',
  type: FilterDefinition.types.range,
  minValue: buildSelector('minYearBuilt'),
  maxValue: buildSelector('maxYearBuilt')
});

export default [
  apnNumber,
  availableSF,
  buildingSize,
  ceilingHeight,
  lotSize,
  mortgageAmount,
  mortgageRecordedDate,
  numKeys,
  numUnits,
  yearBuilt
];
